import { render, staticRenderFns } from "./BrandResultPosts.vue?vue&type=template&id=1eb24ffe"
import script from "./BrandResultPosts.vue?vue&type=script&lang=js"
export * from "./BrandResultPosts.vue?vue&type=script&lang=js"
import style0 from "./BrandResultPosts.vue?vue&type=style&index=0&id=1eb24ffe&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports